import { API } from "@/services/api";
import { helpEndpoints } from "@/constant/endpoints";
import { buildQueryString } from "@/utils/common.utils";
import { HelpArticlesParams, HelpArticlesResponse } from "@/types/help.types";

export const getHelpArticlesService = async (
  params: HelpArticlesParams = {}
): Promise<HelpArticlesResponse> => {
  const response = await API.Get<HelpArticlesResponse>(`${helpEndpoints.articles}${buildQueryString(params)}`);
  if (response.data) return response.data;
  throw new Error(response.message);
};
